module.exports = __webpack_public_path__ + "SC01.c2dacfb8.atlas";